<template>
  <nav>
    <div
      class="hidden sm:hidden md:hidden lg:flex xl:flex items-center bg-gray-100 shadow-lg"
    >
      <div class="flex-none flex-col bg-gray-100">
        <img src="../assets/logo_trans.png" class="h-20 p-4" />
      </div>
      <div class="flex-none flex-col bg-gray-100">
        <div class="flex">
          <div class="flex hover:text-mi-yellow-500">
            <router-link
              :to="{ name: 'Home' }"
              class="flex items-center flex-col"
            >
              <NavMainIcon :icon_name="'search'" :text="'Zoeken'" :active="true"
            /></router-link>
          </div>
          <div class="flex">
            <router-link
              :to="{ name: 'TodoSearchResults' }"
              class="flex items-center flex-col"
            >
              <NavMainIcon
                :icon_name="'check_circle_outline'"
                :text="'Taken'"
                :active="true"
                v-if="hasPermission('read todoitem')"
            /></router-link>
          </div>
        </div>
      </div>
      <div class="flex-grow flex-col bg-gray-100"></div>
      <div class="flex-none flex-col bg-gray-100">
        <div class="flex">
          <div
            class="flex hover:text-mi-yellow-500"
            v-if="hasPermission('update domeinlijst')"
          >
            <router-link
              :to="{
                name: 'EditDomeinlijsten',
                params: { name: 'voorziening_typen' }
              }"
            >
              <NavMainIcon
                :icon_name="'account_tree'"
                :text="'Kenmerken'"
                :active="true"
              />
            </router-link>
          </div>

          <div class="flex">
            <router-link
              :to="{
                name: 'HelpMain'
              }"
            >
              <NavMainIcon
                :icon_name="'help_outline'"
                :text="'Help'"
                :active="true"
              />
            </router-link>
          </div>

          <div
            class="flex hover:text-mi-yellow-500"
            v-if="hasPermission('access admin pages')"
          >
            <router-link
              :to="{
                name: 'EditUsers'
              }"
            >
              <NavMainIcon
                :icon_name="'admin_panel_settings'"
                :text="'Admin'"
                :active="true"
              />
            </router-link>
          </div>

          <div
            class="flex"
            @click="showProfileDropdown = !showProfileDropdown"
            @focusout="showProfileDropdown = false"
            tabindex="0"
          >
            <NavMainIcon
              :icon_name="'person_outline'"
              :text="'Profiel'"
              :active="true"
            />

            <div
              class="dropdown-content absolute bg-gray-200 font-raleway w-40 right-0 border border-black mr-2 px-2 mt-20 shadow-lg"
              :class="{ hidden: !showProfileDropdown }"
            >
              <div
                class="bg-mi-blue-500 -mx-2 text-white text-center font-raleway"
              >
                Profiel
              </div>
              <p class="text-black cursor-pointer" @click="openProfile()">
                Mijn gegevens
              </p>
              <hr />
              <p class="text-black cursor-pointer" @click="signout">Afmelden</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BOTTOM MOBILE NAV -->
    <div
      class="lg:hidden xl:hidden inset-x-0 bottom-0 fixed h-16 bg-transparent z-50"
    >
      <div class="flex flex-row">
        <div class="flex-grow flex-col bg-transparent"></div>
        <div class="flex-none flex-col bg-gray-300 h-12 rounded-lg">
          <i
            class="material-icons md-3xl relative text-mi-purple-400 hover:text-yellow-400 p-3 cursor-pointer"
            @click="openSearchPanel()"
            >search</i
          >

          <i
            class="material-icons md-3xl relative text-gray-400 hover:text-yellow-400 p-3 pr-8"
            >check_circle_outline</i
          >
          <a href="#comment">
            <i
              class="material-icons md-6xl text-mi-purple-400 relative border-white border-solid border-2 hover:text-gray-600 hover:bg-gray-400 bg-gray-300 rounded-full p-2"
              :class="{
                'opacity-100': activateComments,
                'opacity-25 cursor-default': !activateComments
              }"
              >feedback</i
            ></a
          >
          <i
            class="material-icons md-3xl relative text-mi-purple-400 hover:text-yellow-400 p-3 pl-8"
            :class="{
              'opacity-100 cursor-pointer': activateRightNav,
              'opacity-25': !activateRightNav
            }"
            @click="openRightNav()"
            >fitness_center</i
          >
          <i
            class="material-icons md-3xl relative text-mi-purple-400 hover:text-yellow-400 p-3 cursor-pointer"
            @click="openProfile()"
            >person_outline</i
          >
        </div>
        <div class="flex-grow flex-col bg-transparent"></div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions } from "vuex";
import NavMainIcon from "./NavMainIcon";

export default {
  data() {
    return {
      showProfileDropdown: false
    };
  },
  components: {
    NavMainIcon
  },
  computed: {
    activateComments: function() {
      return (
        (this.$router.currentRoute.name == "Accommodatie") |
        (this.$router.currentRoute.name == "Voorziening")
      );
    },
    activateRightNav: function() {
      return (
        (this.$router.currentRoute.name == "Accommodatie") |
        (this.$router.currentRoute.name == "Voorziening")
      );
    }
  },
  methods: {
    openSearchPanel: function() {
      if (this.$router.currentRoute.name !== "Home") {
        this.$router.push({ name: "Home" });
      } else {
        this.$emit("showSearchPane");
      }
    },
    openRightNav: function() {
      if (this.activateRightNav) this.$emit("showRightNav");
    },
    openProfile: function() {
      if (this.$router.currentRoute.name !== "Profile") {
        this.$router.push({ name: "Profile" });
      }
    },
    signout: function() {
      this.logout();
      this.$router.push({ name: "Login" });
    },
    ...mapActions(["logout"])
  }
};
</script>
